// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listtext{
  font-family: "Inter";
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 16.94px !important;
  letter-spacing: 0.02em !important;
  /* text-align: left; */
  width: 100%;
  max-width: 245px;
  text-align: center;

  align-content: center;
  align-items: center;
  align-self: center;
  margin-left: 2%;  
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  overflow: hidden;
}

.todaypath{
  font-family: "Inter";
  font-size: 20px;
  font-style: italic;
  font-weight: 700;
  line-height: 24.2px;
  letter-spacing: 0.02em;
  text-align: left;
  color:#0056B2;
}

.pathName{
  font-family: "Inter";
  font-size: 20px;   
  font-weight: 500;
  line-height: 24.2px;
  letter-spacing: 0.02em;
  text-align: left;
  color: white;
}

.pathName1{
  font-size: 20px; 
  color: orange; 
}

.text-animation {
  overflow: hidden;
  white-space: nowrap;
}

.letter {
  display: inline-block;
  opacity: 0;
  animation: appear 0.5s forwards;
}
  
@keyframes appear {
  from {
    opacity: 0;
    transform: translateY(50%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.darkIcon{
  filter: saturate(50%) brightness(10%) hue-rotate(10deg);
}

.document-view-pagination{
display: flex;
justify-content: center;
}

@media only screen and ( max-width: 1400px) {
  .BackgroundMediaquery {
    min-height: 100vh;
    max-height: auto;
  }
}

@media only screen and (min-width: 1400px) {
  .BackgroundMediaquery {
    height: 100vh;
  }
}






`, "",{"version":3,"sources":["webpack://./src/components/sidebar/sidebar.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,iCAAiC;EACjC,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;;EAElB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,uDAAuD;AACzD;;AAEA;AACA,aAAa;AACb,uBAAuB;AACvB;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".listtext{\r\n  font-family: \"Inter\";\r\n  font-size: 14px !important;\r\n  font-weight: 600 !important;\r\n  line-height: 16.94px !important;\r\n  letter-spacing: 0.02em !important;\r\n  /* text-align: left; */\r\n  width: 100%;\r\n  max-width: 245px;\r\n  text-align: center;\r\n\r\n  align-content: center;\r\n  align-items: center;\r\n  align-self: center;\r\n  margin-left: 2%;  \r\n  text-overflow: ellipsis !important;\r\n  white-space: nowrap !important;\r\n  overflow: hidden;\r\n}\r\n\r\n.todaypath{\r\n  font-family: \"Inter\";\r\n  font-size: 20px;\r\n  font-style: italic;\r\n  font-weight: 700;\r\n  line-height: 24.2px;\r\n  letter-spacing: 0.02em;\r\n  text-align: left;\r\n  color:#0056B2;\r\n}\r\n\r\n.pathName{\r\n  font-family: \"Inter\";\r\n  font-size: 20px;   \r\n  font-weight: 500;\r\n  line-height: 24.2px;\r\n  letter-spacing: 0.02em;\r\n  text-align: left;\r\n  color: white;\r\n}\r\n\r\n.pathName1{\r\n  font-size: 20px; \r\n  color: orange; \r\n}\r\n\r\n.text-animation {\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n}\r\n\r\n.letter {\r\n  display: inline-block;\r\n  opacity: 0;\r\n  animation: appear 0.5s forwards;\r\n}\r\n  \r\n@keyframes appear {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(50%);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.darkIcon{\r\n  filter: saturate(50%) brightness(10%) hue-rotate(10deg);\r\n}\r\n\r\n.document-view-pagination{\r\ndisplay: flex;\r\njustify-content: center;\r\n}\r\n\r\n@media only screen and ( max-width: 1400px) {\r\n  .BackgroundMediaquery {\r\n    min-height: 100vh;\r\n    max-height: auto;\r\n  }\r\n}\r\n\r\n@media only screen and (min-width: 1400px) {\r\n  .BackgroundMediaquery {\r\n    height: 100vh;\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
